import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogin, authRegister, authLogout } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user

  useEffect(() => {
    authMe()
      .then(setUser)
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const u = await authLogin({ email, password });
    setUser(u);
    return u;
  }, []);

  const register = useCallback(async (name, email, password) => {
    let referralCode = null;
    try {
      const ref = JSON.parse(localStorage.getItem("mm_ref") || "null");
      if (ref && ref.exp > Date.now()) referralCode = ref.code;
    } catch {}
    const u = await authRegister({ name, email, password, referralCode });
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(async () => {
    try {
      await authLogout();
    } catch {}
    setUser(false);
  }, []);

  const refresh = useCallback(() => {
    return authMe().then(setUser).catch(() => setUser(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
